import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { LightboxServicePageConfig } from '../types'
import { name, VIEWER_SERVICE_PACKAGE_NAME } from '../symbols'

const lightboxServicePageConfig: PageConfigFn<LightboxServicePageConfig> = (
	{ activeServices }: VsmContext,
	_pageId: string
) => {
	const shouldLoadPageFeature = activeServices.isActive(VIEWER_SERVICE_PACKAGE_NAME)

	return {
		shouldLoadPageFeature,
		pageConfig: {},
	}
}

export const pageConfig: PageConfigEntry<LightboxServicePageConfig> = {
	name,
	configFactory: lightboxServicePageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
